interface IQueryParam {
  badges?: Array<unknown>;
}

const filterHelp = (queryParam: IQueryParam, badge: string) => {
  if (Array.isArray(queryParam.badges)) {
    return queryParam?.badges?.find(element => element == badge);
  }

  return false;
};

export default filterHelp;
export { filterHelp };
